import { navigate } from 'gatsby'

import { navigateUsingWindow } from './navigateUsingWindow'
import { account } from '../../../../store.config'

// Credentials
export const goToLogin = (loginUrl: string, returnUrl?: string) => {
  const returnQuery = returnUrl ? `?returnUrl=${returnUrl}` : ''

  navigateUsingWindow(`${loginUrl}${returnQuery}`)
}

// Club Card Plus
export const goToBenefitsClubCardPlus = () => {
  if (
    account === 'avenidab2c' ||
    account === 'superpao' ||
    account === 'compremais'
  ) {
    navigate(`https://www.clubemaisamigo.com.br/`)
  } else {
    navigate(`/cartao/beneficios-cartao${window?.location?.search}`)
  }
}

// Club
export const goToClub = () => {
  navigate(`/clube`)
}

// Savings
export const goToSavings = () => {
  navigate(`/econometro`)
}

export const goToSavingsDiscountByCategory = (categoryName?: string) => {
  navigate(
    `/econometro/desconto-por-categoria${categoryName ? `?openCategory=${categoryName}` : ''}`
  )
}

// Points Redemption

export const goToPointsRedemptionPDP = (sku: string) => {
  navigate(`/resgate-de-pontos/${sku}/p`)
}
